module.exports = __webpack_public_path__ + "static/media/regular-recommendation.266c4fd4.svg";